import {inject, reactive} from "vue";

class Popup {
    app;
    _list = reactive([]);
    options = {};


    constructor(app, popups = []) {
        this.app = app;
        popups.forEach(p => this.open(p));
    }

    all() {
        return this._list;
    }

    topOnly() {
        return this._list.filter(popup => popup.position === 'top');
    }

    regular() {
        return this._list.filter(popup => popup.position !== 'top');
    }

    open(options = {}) {
        options.id = options.id || Date.now() + Math.random(0, 100);
        if (this._list.find(p => p.id === options.id)) return;
        this._list.push(options);
    }

    close(id) {
        const index = this._list.findIndex(p => p.id === id);
        if (index === -1) return;
        this._list.splice(index, 1);
    }
}

export default {
    install(app, popups = []) {
        const popup = new Popup(app, popups);
        app.config.globalProperties.$popup = popup.open.bind(popup);
        app.provide('popup', popup);
    }
}

export function usePopup() {
    return inject('popup');
}